import { createAsyncThunk } from "@reduxjs/toolkit";
import { exitStaff, StaffExitReasonListService, StaffListService } from "../../services/user/staffListService";
export const fetchStaffListAsync = createAsyncThunk(
  "staff/PendingStaffList",
  async ({pageNumber,rowsPerPage,key}:any,thunkAPI) => {
    // Add thunkAPI as the second argument
    const response = await StaffListService(pageNumber,rowsPerPage,key);
    return response;
  }
);
export const fetchReasonForExitListAsync = createAsyncThunk(
  "staff/StaggExitReasonForExitList",
  async (thunkAPI) => {
    console.log("fetchReasonForExitListAsync"); 
    // Add thunkAPI as the second argument
    const response = await StaffExitReasonListService();
    return response;
  }
);

export const exitStaffAsync = createAsyncThunk(
  "staff/exitStaff",
  async ({userId,data}:any) => {
    const response = await exitStaff(userId,data);
    return response;
  }
);
